/**
 * widgets/registry.supabase.tsx — Supabase widgety (2.1).
 *
 * Custom panely z pages/modules/supabase/panels.tsx.
 * Data: callWidgetTool + scope (node-aware). Chrome kreslí WidgetShell.
 */
import { Database, Layers, Users } from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  InstancesPanel,
  SchemataPanel,
  UsersPanel,
} from '../pages/modules/supabase/panels';

export const SUPABASE_WIDGETS: WidgetSpec[] = [
  {
    id: 'supabase.instances',
    title: 'Supabase instance',
    module: 'supabase',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Database,
    since: '2.1.0',
    component: InstancesPanel,
  },
  {
    id: 'supabase.schemata',
    title: 'Supabase schemata',
    module: 'supabase',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Layers,
    since: '2.1.0',
    component: SchemataPanel,
  },
  {
    id: 'supabase.users',
    title: 'Supabase ACL / users',
    module: 'supabase',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Users,
    since: '2.1.0',
    component: UsersPanel,
  },
];
